$(document).ready(function () {
    $(function () {
        $('[data-toggle="tooltip"]').tooltip()
    });

    $('a.comment-reply').on('click', function (e) {
        e.preventDefault();

        var $this = $(this),
            $commentRow = $this.closest('div.comment-row'),
            commentId = $commentRow.data('comment-id'),
            commentLevel = $commentRow.data('comment-level'),
            formAction = $commentRow.data('form-action'),
            btnLabel = $commentRow.data('reply-btn-label'),
            btnCancelLabel = $commentRow.data('cancel-btn-label'),
            textAreaReplyLabel = $('textarea.comment-text').data('placeholder-reply');

        if (commentLevel >= 6 || $this.hasClass('disabled')) {
            return false;
        }

        $this.closest('div.comments-wrapper').find('div.reply-row').slideUp('fast', function () {
            $(this).closest('div.comments-wrapper').find('a.comment-reply').not($this).fadeIn('fast');
            $(this).remove();
        });

        var $replyContent = $commentRow.parents('div#comment-section').find('div.create-comment-wrapper').clone(),
            $replyRow = $('<div>', {'class': 'row reply-row', 'html': $replyContent}),
            $btnReply = $replyRow.find("button");

        $replyRow.find('textarea.comment-text')
            .attr('placeholder', textAreaReplyLabel)
            .val('');

        $replyRow.find('input.comment-text')
            .removeClass('comment-text')
            .addClass('comment-reply-text');

        $replyRow.find('div.create-comment-wrapper')
            .removeClass('create-comment-wrapper')
            .addClass('create-reply-wrapper');

        $replyRow.find('form').prepend($('<input>', {'type': 'hidden', 'name': 'parentId', 'val': commentId}));


        $btnReply.text(btnLabel)
            .removeClass('btn-comment')
            .addClass('btn-reply')
            .attr('onclick', null)
            .prepend($('<span>', {'class': 'glyphicon glyphicon-share-alt margin-right-5px'}))
            .after($('<button>', {
                'class': 'btn btn-danger btn-reply-cancel pull-right margin-top-10px margin-right-5px',
                'html': $('<span>', {'class': 'glyphicon glyphicon-remove margin-right-5px'})[0].outerHTML + btnCancelLabel,
                'type': 'reset'
            }))
            .on('click', function (e) {
                if (!confirm($btnReply.data('confirm-reply-message'))) {
                    e.preventDefault();
                }
            });

        $replyRow.attr('action', formAction);

        $replyRow.hide().insertAfter($commentRow.find('> div.comment-content-wrapper > div > div.comment-content').parent()).slideDown('fast');

        $this.fadeOut('fast');
    });

    $('div.comments-wrapper div.comment-row').eq(-1).addClass('last');
    $('div.comments-wrapper div.comment-row').eq(-1).parent().closest('div.comment-row').addClass('last-parent');

    $(document).on('click', 'button.btn-reply-cancel', function () {
        $(this).parents('div.reply-row').slideUp('fast', function () {
            $(this).parents('div.comment-content-wrapper').find('> div > div.comment-footer > div > div > a.comment-reply').fadeIn('fast');
            $(this).remove();
        });
    });

    $('a.comment-edit').on('click', function (e) {
        e.preventDefault();

        var $this = $(this),
            $commentRow = $this.closest('div.comment-row'),
            commentId = $commentRow.data('comment-id'),
            $commentTextWrapper = $commentRow.find('> div.comment-content-wrapper > div > div.comment-content > div.comment-text-wrapper'),
            editAction = $commentTextWrapper.data('edit-action'),
            editCommentSaveBtnLabel = $commentTextWrapper.data('edit-save-btn-label'),
            editCommentCancelBtnLabel = $commentTextWrapper.data('edit-cancel-btn-label');

        $this.fadeOut('fast');

        $commentTextWrapper
            .wrapInner($('<textarea>', {
                'class': 'form-control',
                'name': 'comment',
                'style': 'resize: none; height: 80px; width: 100%;'
            }).wrap($('<div>', {'class': 'form-group'})).parent())
            .wrapInner($('<form>', {
                'method': 'POST',
                'class': 'form-edit-comment',
                'action': editAction
            })).hide().slideDown('fast');

        $commentTextWrapper.children('form.form-edit-comment').prepend($('<input>', {
            'type': 'hidden',
            'name': '_method',
            'value': 'PATCH'
        }));

        $commentTextWrapper.children('form.form-edit-comment').prepend($('<input>', {
            'type': 'hidden',
            'name': 'comment_id',
            'val': commentId
        }));

        $commentTextWrapper.children('form.form-edit-comment').prepend($('<input>', {
            'type': 'hidden',
            'name': '_token',
            'val': window.Laravel.csrfToken
        }));

        $commentTextWrapper.children('form.form-edit-comment').append($('<button>', {
            'type': 'submit',
            'class': 'btn btn-primary pull-right margin-top-10px',
            'html': $('<span>', {'class': 'glyphicon glyphicon-ok margin-right-5px'})[0].outerHTML + editCommentSaveBtnLabel
        })).append($('<button>', {
            'type': 'reset',
            'class': 'btn btn-danger edit-comment-cancel pull-right margin-top-10px margin-right-5px',
            'html': $('<span>', {'class': 'glyphicon glyphicon-remove margin-right-5px'})[0].outerHTML + editCommentCancelBtnLabel
        })).wrapInner($('<div>', {'class': 'form-group'}));

        $('html, body').animate({
            scrollTop: $commentRow.offset().top
        }, 1000);
    });

    $(document).on('click', 'button.edit-comment-cancel', function () {
        $(this).parents('div.comment-text-wrapper').slideUp('fast', function () {
            var $this = $(this),
                commentText = $this.find('> form.form-edit-comment textarea').val().replace(/\n/g, '<br>');

            $this.children('form').remove();
            $this.html(commentText).slideDown('fast');

            $this.parents('div.comment-content-wrapper').find('> div > div.comment-footer > div > div > a.comment-edit').fadeIn('fast');
        });
    });

    $(document).on('click', 'a.submit-form', function (e) {
        e.preventDefault();

        var $this = $(this);

        if ($this.hasClass('confirm')) {
            if (confirm($this.data('confirm-message'))) {
                $this.parents('form').submit();
            }
        } else {
            $this.parents('form').submit();
        }
    });
});